import type { CSSProperties } from 'react'

// eslint-disable-next-line react-refresh/only-export-components
export const CHANNELS: Record<string, { bg: string; fg: string; mark: string }> = {
  Salla:    { bg: '#FFE5DD', fg: '#C2410C', mark: 'S' },
  Noon:     { bg: '#FEF3C7', fg: '#854D0E', mark: 'N' },
  Amazon:   { bg: '#1F2937', fg: '#FACC15', mark: 'a' },
  Zid:      { bg: '#FCE7F3', fg: '#9D174D', mark: 'Z' },
  Trendyol: { bg: '#FFEDD5', fg: '#B91C1C', mark: 'T' },
}


interface ChannelDotProps {
  name: string
  size?: number
  dim?: boolean
  style?: CSSProperties
}

export function ChannelDot({ name, size = 22, dim = false, style }: ChannelDotProps) {
  const c = CHANNELS[name] || { bg: '#E2E8F0', fg: '#64748B', mark: '?' }
  return (
    <div
      title={name}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.3,
        background: dim ? 'var(--ink-100)' : c.bg,
        color: dim ? 'var(--ink-300)' : c.fg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.5,
        fontWeight: 800,
        fontFamily: 'Nunito, sans-serif',
        flexShrink: 0,
        transition: 'all 200ms',
        ...style,
      }}
    >
      {c.mark}
    </div>
  )
}

interface ChannelPillProps {
  name: string
  size?: 'sm' | 'md'
  style?: CSSProperties
}

export function ChannelPill({ name, size = 'md', style }: ChannelPillProps) {
  const c = CHANNELS[name] || { bg: 'var(--ink-100)', fg: 'var(--ink-800)', mark: '?' }
  const sz: CSSProperties = size === 'sm'
    ? { fontSize: 10.5, padding: '3px 8px' }
    : { fontSize: 11.5, padding: '4px 10px' }
  return (
    <span style={{
      borderRadius: 999,
      fontWeight: 700,
      background: c.bg,
      color: c.fg,
      whiteSpace: 'nowrap',
      ...sz,
      ...style,
    }}>
      {name}
    </span>
  )
}
